export const organizationKeys = {
  all: ['organization'] as const,
  list: () => [...organizationKeys.all, 'list'] as const,
}
